import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.js'
import './styles/globals.css'
import { ensureFreshAppOnBoot } from './utils/appCache'
import { listenForPwaInstallPrompt, registerRiderServiceWorker } from './utils/registerPwa'
import { soundService } from './services/sound.service'

ensureFreshAppOnBoot()
void registerRiderServiceWorker()
listenForPwaInstallPrompt()

// Prime alert audio on the first user gesture. Browsers block sound until the
// document has user activation, so without this the job alert would never ring.
soundService.installUnlock()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
